import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Suppliers/OutStandingStatement/tables";
import headers from "../../../../Data/Tables/Suppliers/OutStandingStatement/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { useParams } from "react-router-dom";
import { get_all_purchases } from "../../../../Controllers/Purchases/Orders";
import DateTimeBadge from "../../../../Componets/DateTime/DateTimeBadge";

const SupplierOutstandingStatement = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalPurchases: 0,
    totalAmount: 0,
    overdueAmount: 0,
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const { id } = useParams();

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      supplier: headerdata?.supplier,
      status: headerdata?.status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const calculateTotalPaid = (purchase) => {
    if (!purchase?.payments || !Array.isArray(purchase?.payments)) return 0;
    return purchase.payments.reduce(
      (sum, payment) => sum + (payment.amount || 0),
      0
    );
  };

  const calculateOutstanding = (purchase) => {
    const total = purchase?.total || 0;
    const paid = calculateTotalPaid(purchase);
    return total - paid;
  };

  const isOverdue = (purchase) => {
    if (!purchase?.due_date) return false;
    return new Date(purchase.due_date) < new Date();
  };



  const fetchSummary = async () => {
    try {
      const params = {
        supplier: id,
        source: "Supplier-Outstanding-Statement",
      };

      const response = await get_all_purchases(params);

      console.log("Summary Response:", response);

      if (response?.status) {
        const purchases = response?.data?.data || [];
        let totalOutstanding = 0;
        let overdueAmount = 0;
        let totalAmount = 0;

        purchases.forEach((purchase) => {
          const outstanding = calculateOutstanding(purchase);
          totalOutstanding += outstanding;
          totalAmount += purchase?.total || 0;

          if (purchase.due_date && outstanding > 0) {
            if (new Date(purchase.due_date) < new Date()) {
              overdueAmount += outstanding;
            }
          }
        });

        setSummary({
          totalOutstanding,
          totalPurchases: response?.data?.totalCount || purchases.length,
          overdueAmount,
          totalAmount,
        });
      } else {
        toast.error("Failed to fetch summary");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        supplier: tabledata?.supplier || id,
        status: tabledata?.status,
        date: tabledata?.date,
        page: tabledata?.currentPage || 1,
        limit: 10,
        source: "Supplier-Outstanding-Statement",
      };

      const purchasesResponse = await get_all_purchases(params);

      if (purchasesResponse?.status) {
        let purchases = purchasesResponse?.data?.data || [];

        purchases = purchases.filter(
          (purchase) => calculateOutstanding(purchase) > 0
        );

        const startIndex = ((params.page || 1) - 1) * params.limit;
        const paginatedPurchases = purchases.slice(
          startIndex,
          startIndex + params.limit
        );

        const tableData = paginatedPurchases.map((purchase) => {
          const outstanding = calculateOutstanding(purchase);
          const paidAmount = calculateTotalPaid(purchase);
          const overdue = isOverdue(purchase);

          return {
            path: `/app/purchases/orders/view/${purchase?._id}`,
            "PO Number": `#PO-${purchase.number}`,
            Supplier: purchase.supplier?.name || "N/A",
            Date: <DateTimeBadge date={purchase?.date} />,
            "Due Date": purchase.due_date
              ? <DateTimeBadge date={purchase?.due_date} />
              : "-",
            "Total Amount": `OMR ${(purchase.total || 0).toFixed(3)}`,
            "Paid Amount": `OMR ${paidAmount.toFixed(3)}`,
            Outstanding: `OMR ${outstanding.toFixed(3)}`,
            "Payment Status":
              purchase?.payment_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : purchase?.payment_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            "Delivery Status":
              purchase?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : purchase?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
          };
        });

        setBody(tableData);

        setPagination({
          currentPage: params.page || 1,
          totalCount: purchases.length,
          totalPages: Math.ceil(purchases.length / params.limit),
        });
      } else {
        toast.error("Failed to fetch invoices");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    if (id) {
      fetchData();
      fetchSummary();
    }
    headerReset();
  }, [id]);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 mt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              OMR {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Purchases</h3>
            <p className=" text-green-600">{summary.totalPurchases}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Amount</h3>
            <p className=" text-green-600">
              OMR {summary.totalAmount.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              OMR {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>
        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
            summary={2}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default SupplierOutstandingStatement;